import { render } from "./AccountEdit.vue?vue&type=template&id=1afa4a58"
import script from "./AccountEdit.vue?vue&type=script&lang=ts"
export * from "./AccountEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script